import React from 'react'

const Container = ({children, className, style, color}) => {
  return (
    <section style={{background: color ? color : 'transparent', ...style}}>
      <div className={`container mx-auto ${className}`}>
        {children}
      </div>
    </section>
  )
}

export { Container }